import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { CiEdit } from 'react-icons/ci';
import { MdDelete } from "react-icons/md";
import { FaUserLock } from "react-icons/fa";
import { Button, Pagination } from '@mui/material';
import { json, useNavigate } from 'react-router-dom';
import ViewAllEmployees from '../../../component/b2c/models/ViewAllEmployee';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { HiUsers } from "react-icons/hi";
import { toast } from 'react-toastify';
import { Base_Url, AllEmployeeList,deleteEpmloyee } from '../../../config/config';
import SetPermission from '../../../component/b2c/models/setPermissionModel';

const AllEmployee = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpenPermission, setIsPopupOpenPermission] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [employee, setEmployee] = useState([]);
  const [empLoyeePermission, setEmployeePermission] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const itemsPerPage = 8;

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10); 

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit,setEmployee]); 


  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const url_for_allEmployee = `${Base_Url}${AllEmployeeList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(url_for_allEmployee, {
        method: 'GET',
        headers: {
        'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS") {
        setEmployee(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
      }
    } catch (error) {
    }
  };


  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  

  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setIsPopupOpen(true);
  };


  const handleClose = () => {
    setIsPopupOpen(false);
  };


  const handleViewPermissionPopup =(employee) =>{
    setIsPopupOpenPermission(true);
    setEmployeePermission(employee);

  }

  const handleClosePermissionPopup = () => {
    setIsPopupOpenPermission(false);
  };


  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
    const urldelete = Base_Url + deleteEpmloyee;
  
    try {
      const token = localStorage.getItem('token');
      const cusid = localStorage.getItem('cus_id');
  
      const response = await fetch(`${urldelete}/${id}`, {
        method: 'GET', 
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
  
      const data = await response.json();
  
      if (data.status === "success") {
        setEmployee((prevWarehouses) => prevWarehouses.filter(employee => employee.id !== id));
        toast.success(data.message);
        setTotalOrders((prev) => prev - 1);
        fetchWarehouses();
    
      } else {
        toast.error( data.message);
      }
  
    } catch (error) {
      toast.error( error.message);
    }
  };

  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
        <div className="z-10 shrink-0">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent  md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
            style={
              window.innerWidth < 768 
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
              <Sidebar />
            </div>
          )}

          <div className="flex-1 dark:bg-black p-4 md:p-5 w-full bg-gray-200 overflow-hidden flex flex-col">

            {/* Header */}
            <div className="flex-shrink-0 flex items-center gap-3 mb-4 pb-3 border-b border-gray-200 dark:border-gray-800">
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${isDarkMode ? 'bg-white text-black' : 'bg-blue-600 text-white'}`}>
                <HiUsers color="white" size={16} />
              </div>
              <div>
                <h1 className="text-sm font-bold text-gray-800 dark:text-white tracking-tight">All Employees</h1>
                <p className={`text-[9px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Manage your team members and permissions</p>
              </div>
              <span className={`ml-auto text-[9px] font-medium px-2.5 py-0.5 rounded-full border ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-300 text-gray-500'}`}>
                {totalOrders} total
              </span>
            </div>

            {/* Table - Scrollable */}
            <div className="flex-1 overflow-y-auto overflow-x-auto custom-scrollbar rounded-lg border border-gray-200 dark:border-gray-800">
              <table className="min-w-full w-full border-collapse table-auto">
                <thead className="sticky top-0 z-10">
                  <tr className={`${isDarkMode ? 'bg-white text-black' : 'bg-blue-600 text-white'} text-[9px] uppercase tracking-wider`}>
                    <th className="p-2.5 text-left w-12 font-semibold">ID</th>
                    <th className="p-2.5 text-left font-semibold">Name</th>
                    <th className="p-2.5 text-left font-semibold hidden sm:table-cell">Email</th>
                    <th className="p-2.5 text-left w-24 font-semibold">Phone</th>
                    <th className="p-2.5 text-center w-36 font-semibold">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {employee.reverse().map((employee, index) => (
                    <tr
                      key={employee.id}
                      className={`border-t ${isDarkMode ? 'border-gray-800' : 'border-gray-200'} ${
                        index % 2 === 0
                          ? (isDarkMode ? 'bg-black' : 'bg-white')
                          : (isDarkMode ? 'bg-gray-900/30' : 'bg-gray-50')
                      } hover:${isDarkMode ? 'bg-gray-800/60' : 'bg-gray-100'} transition-colors`}
                    >
                      <td className={`p-2.5 text-[10px] font-mono ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{employee.id}</td>
                      <td className="p-2.5 text-[10px] font-medium text-gray-800 dark:text-white">{employee.name}</td>
                      <td className={`p-2.5 text-[10px] hidden sm:table-cell ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{employee.email}</td>
                      <td className={`p-2.5 text-[10px] font-mono ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{employee.phone}</td>
                      <td className="p-2.5">
                        <div className="flex items-center justify-center gap-1.5">
                          <button
                            onClick={() => handleViewClick(employee)}
                            title="View"
                            className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                              isDarkMode 
                                ? 'border-gray-700 text-gray-300 hover:bg-white hover:text-black hover:border-white' 
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                            }`}
                          >
                            <IoMdEye size={13} />
                          </button>
                          <button
                            title="Edit"
                            className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                              isDarkMode 
                                ? 'border-gray-700 text-gray-300 hover:bg-white hover:text-black hover:border-white' 
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                            }`}
                          >
                            <CiEdit size={13} />
                          </button>
                          <button
                            onClick={() => handleDelete(employee.employee_id)}
                            title="Delete"
                            className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                              isDarkMode 
                                ? 'border-gray-700 text-gray-300 hover:bg-white hover:text-black hover:border-white' 
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                            }`}
                          >
                            <MdDelete size={13} />
                          </button>
                          <button
                            onClick={() => handleViewPermissionPopup(employee)}
                            title="Permissions"
                            className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                              isDarkMode 
                                ? 'border-gray-700 text-gray-300 hover:bg-white hover:text-black hover:border-white' 
                                : 'border-gray-300 text-gray-600 hover:bg-black hover:text-white hover:border-black'
                            }`}
                          >
                            <FaUserLock size={12} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {employee.length === 0 && (
                    <tr>
                      <td colSpan="5" className="p-6 text-center text-[11px] text-gray-400 dark:text-gray-500">
                        No employees found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer / Pagination - Fixed */}
            <div className="flex-shrink-0 mt-3 pt-3 border-t border-gray-200 dark:border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-2">
              <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Total: <span className="text-gray-800 dark:text-white font-semibold">{totalOrders}</span> employees
              </span>

              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`rounded-lg px-2.5 py-1 text-[9px] border focus:outline-none focus:ring-1 ${
                    isDarkMode 
                      ? 'bg-black border-gray-700 text-white focus:ring-gray-500' 
                      : 'bg-white border-gray-300 text-gray-700 focus:ring-gray-400'
                  }`}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={totalOrders}>All</option>
                </select>

                <Pagination
                  count={Math.ceil(totalOrders / limit)}
                  page={page}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      color: isDarkMode ? '#fff' : '#000',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? '#fff' : '#000',
                        color: isDarkMode ? '#000' : '#fff',
                        borderColor: isDarkMode ? '#fff' : '#000',
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <ViewAllEmployees isopen={isPopupOpen} onClose={handleClose} employee={selectedEmployee} />
        <SetPermission isopen={isPopupOpenPermission} onClose={handleClosePermissionPopup} selectedEmpForSetPermission={empLoyeePermission} />
      </div>
    </>
  );
};

export default AllEmployee;